<template>
  <div class="aweber-callback">
    <p v-if="loading">Processing your AWeber integration...</p>
    <p v-if="error" class="error">{{ error }}</p>
  </div>
</template>

<script>
import axios from 'axios'
import { APIEndpoint } from '@api/_version'

export default {
  name: 'AWeberOAuthCallback',
  data() {
    return {
      loading: true,
      error: null,
    }
  },
  created() {
    const code = this.$route.query.code
    const state = this.$route.query.state

    if (!code || !state) {
      this.error = 'Authorization code or state not found in URL.'
      this.loading = false
      return
    }

    // Send the authorization code and state to the backend
    axios.post(`${APIEndpoint}/api/aweber/callback/`, { code, state })
        .then(response => {
          const integrationId = response.data.id
          const integrationType = 'AWEBER'

          // Use postMessage to communicate with the main window
          if (window.opener && !window.opener.closed) {
            window.opener.postMessage(
                { type: 'OAUTH_COMPLETE', integrationType, integrationId },
                process.env.VUE_APP_FRONTEND_ORIGIN,
            )
            window.close()
          } else {
            this.error = 'Main window is not accessible. Please try again.'
          }
        })
        .catch(error => {
          this.error = 'Failed to complete AWeber OAuth. Please try again.' // Updated error message
          console.error(error)
        })
        .finally(() => {
          this.loading = false
        })
  },
}
</script>

<style scoped>
.aweber-callback {
  text-align: center;
  margin-top: 50px;
}

.error {
  color: red;
}
</style>